export default (theme) => ({
    root: theme.softpro.safeBox,
});
